var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFundHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.009,
    height: 30.633,
    viewBox: "0 0 35.009 30.633",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "briefcase",
    d: "M21.881,52.787a1.094,1.094,0,0,1-1.094,1.094H14.223a1.094,1.094,0,0,1-1.094-1.094V49.5H0v9.846a3.365,3.365,0,0,0,3.282,3.282H31.727a3.365,3.365,0,0,0,3.282-3.282V49.5H21.881Zm9.846-14.223h-5.47V35.282A3.365,3.365,0,0,0,22.975,32H12.034a3.365,3.365,0,0,0-3.282,3.282v3.282H3.282A3.365,3.365,0,0,0,0,41.846v5.47H35.009v-5.47A3.365,3.365,0,0,0,31.727,38.564Zm-9.846,0H13.128V36.376h8.752Z",
    transform: "translate(0 -32)",
    fill: "#00539f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundHouse);
export default __webpack_public_path__ + "static/media/fund_house.de11568cfa4ba4e4297c927acd07a64f.svg";
export { ForwardRef as ReactComponent };